import React from "react";
import "../../styles/App.css";
import { connect } from "react-redux";
import Search from './Search';
import UpDownArrow from './UpDownArrow';
import EditSaveBtn from './EditSaveBtn'
import {sortByField, duplicateData, editData, deleteData, addData} from '../../actions/postActions'

class Table extends React.Component {

  constructor(props){
    super(props);
    this.onArrowClick =this.onArrowClick.bind(this)
  }

  componentWillMount(){
    this.props.duplicateData(this.props.dataName)
  }

  createDataRows(){
    console.log('creating data rows')
    let renderedRows = [];
    let data = this.props.modifiedState.newcontacts;
    let fieldKeys;
    console.log(data)
    if(data.length > 0){
      fieldKeys = Object.keys(data[0]);
    } 
    for(let i=0; i <= data.length -1; i++){
      let tds =[]

      tds.push(<td key={fieldKeys.length+3}><input type="checkbox"/></td>)
      
      for(let j=0; j <= fieldKeys.length -1; j++){
        tds.push(
          <td 
            className ='tableCell'
            id = {data[i].id+fieldKeys[j]+this.props.dataName}
            key={j}
            >{data[i][fieldKeys[j]]}</td>
        )
      }
      tds.push(<td 
        className = 'rowDataEdit'
        id= {data[i].id+' '+fieldKeys.length+'Edit'} 
        key= {fieldKeys.length}
        onClick = {() => this.onRowEdit(data[i].id)}
        >	
          <EditSaveBtn ref={(rowEdit) =>this[data[i].id+this.props.dataName+'Edit'] = rowEdit}/></td>)
      tds.push(<td 
        className = 'rowDataDelete'
        id= {data[i].id} 
        key= {fieldKeys.length+1}
        onClick = {() => this.onRowDelete(data[i].id)}
        > &#x1F5D1;</td>)
      renderedRows.push(<tr key = {i}>{tds}</tr>)
    }
    return renderedRows;
  }

  createDataHeader(){
    console.log('creating data header')
    let headers = Object.values(this.props.headerObj[0]);
    let headerKeys = Object.keys(this.props.headerObj[0]);
    let ths =[];
    ths.push(<th key = {headers.length}><input type="checkbox"/></th>)
    for(let i =0; i<= headers.length-1; i++){
      ths.push(
        <th className='tableCell' key = {i}>
          {headers[i]}
          <UpDownArrow
            onArrowClick = {this.onArrowClick}
            ref={(fieldArrow)=>this[headerKeys[i] + 'Arrow'] = fieldArrow}
            id= {headerKeys[i]} 
          />
        </th>
      )
    }
    return ths;    
  }

  onArrowClick(headerKeyActive, isDown){
    Object.keys(this.props.headerObj[0]).forEach(headerKey =>{
      if(headerKey !== headerKeyActive){
        this[headerKey + 'Arrow'].defaultDownArrow()
      }
    })
    this.props.sortByField(headerKeyActive, isDown, this.props.dataName)
  }
  
  onRowEdit(rowID){
    let refEditSaveBtn = this[rowID+this.props.dataName+'Edit']
    if(!refEditSaveBtn.isEditMode()){
      let fieldKeys = Object.keys(this.props.headerObj[0]).filter(e => e !== 'id')
      fieldKeys.forEach(element=>{
        let textContent = (document.getElementById(rowID+element+this.props.dataName).textContent)
        let node = document.createElement("INPUT")
        let attType = document.createAttribute("type")
        let attValue = document.createAttribute('value')
        attType.value = 'text'
        attValue.value = textContent
        node.setAttributeNode(attType)
        node.setAttributeNode(attValue)
        document.getElementById(rowID+element+this.props.dataName).textContent = ''
        document.getElementById(rowID+element+this.props.dataName).appendChild(node)
      })
      refEditSaveBtn.reverseSaveEditMode()      
    }
    else{
      let fieldKeys = Object.keys(this.props.headerObj[0])
      let changedObject = {};
      fieldKeys.forEach(key=>{
        let nodeBeforeInput = document.getElementById(rowID+key+this.props.dataName)
        changedObject[key] = (key === 'id')?
        Number(nodeBeforeInput.textContent)
        :
        nodeBeforeInput.firstChild.value.trim()
        
        if(key !== 'id'){
          nodeBeforeInput.textContent = (nodeBeforeInput.firstChild.value)? nodeBeforeInput.firstChild.value.trim():nodeBeforeInput.firstChild.value
        }
      })
      this.props.editData(changedObject, this.props.dataName)
      refEditSaveBtn.reverseSaveEditMode()   
    }   
  }
  onRowDelete(rowID){
    if(window.confirm('Are you sure you want to delete this data? ID: ' + rowID)){
      this.props.deleteData(rowID, this.props.dataName)
    }    
  }
  onClickAddBtn(){
    this.props.addData(this.props.dataName)
  }

  render() {
    return (
      <div>
        <Search headerNames = {this.props.headerNames} dataName = {this.props.dataName}/>
        <div><button onClick = {this.onClickAddBtn.bind(this)}>Add</button></div>
        <table>
          <thead>
            <tr>
              {this.createDataHeader()}
            </tr>
          </thead>
          <tbody>
            {this.createDataRows()}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    headerObj: state[props.headerNames],
    modifiedState: state
    /* duplicatedData: state['new' + props.dataName],
    duplicatedData2: state['newcontacts'],  Need to understand why these won't work*/
  };
};

const mapDispatchToProps = (dispatch) =>{
  return {
    sortByField: (headerKeyActive,isDown, dataName) => dispatch(sortByField(headerKeyActive, isDown, dataName)),
    duplicateData: (dataName) => dispatch(duplicateData(dataName)),
    editData: (changedDataObj, dataName) => dispatch(editData(changedDataObj, dataName)),
    deleteData: (rowID, dataName) => dispatch(deleteData(rowID, dataName)),
    addData: (dataName) => dispatch(addData(dataName))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Table);
